import React from 'react';
import BlockRenderer from 'shared/blocks/render';

export default ({ slug }) => (
  <div className="page">
    <BlockRenderer slug={slug} setTitle />
  </div>
);
